import React from 'react'
import PropTypes from 'prop-types'
import LinearProgress from '@material-ui/core/LinearProgress'
import { KEYDOWN } from '../../utils/dom/dom-events'

const styles = require('./progress.scss')

export class Progress extends React.Component {
    timeoutId = null

    static propTypes = {
        visible: PropTypes.bool.isRequired,
        minVisibleTimeMs: PropTypes.number.isRequired,
        maxInvisibleTimeMs: PropTypes.number.isRequired,
    }

    state = {
        visible: false
    }

    componentDidMount() {
        window.addEventListener(KEYDOWN, this.blockKeyBoard)
        this.checkProps()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.visible !== this.props.visible) this.checkProps()
    }

    componentWillUnmount() {
        window.removeEventListener(KEYDOWN, this.blockKeyBoard)
        clearTimeout(this.timeoutId)
    }

    checkProps = () => {
        const { maxInvisibleTimeMs, minVisibleTimeMs, visible } = this.props

        clearTimeout(this.timeoutId)

        if (visible) {
            this.timeoutId = setTimeout(() => {
                this.setState({ visible: true })
            }, maxInvisibleTimeMs)
        } else {
            this.timeoutId = setTimeout(() => {
                this.setState({ visible: false })
            }, minVisibleTimeMs)
        }
    }

    blockKeyBoard = event => {
        if (this.state.visible) {
            event.preventDefault()
        }
    }

    render() {
        const { visible } = this.state

        if (!visible) {
            return null
        }

        return (
            <LinearProgress className={styles.progress} />
        )
    }
}
